const MapLayerGroup = {
	DEFAULT_LAND: "Mapbox - Land",
	DEFAULT_WATER: "Mapbox - Water",
	SATELLITE_TILES: "Satellite Tiles",
	BATHYMETRY: "Bathymetry",
	NATIONALGRID_UNDERSEA_CABLES: "Undersea Cables (NG)",
	DEFAULT_BUILDINGS: "Mapbox - Buildings",
	DEFAULT_TUNNELS: "Mapbox - Tunnels",
	DEFAULT_ROADS: "Mapbox - Roads",
	DEFAULT_BRIDGES: "Mapbox - Bridges",
	DEFAULT_BOUNDARIES: "Mapbox - Boundaries",
	DEFAULT_LABELS: "Mapbox - Labels",
	NAUTICAL_CHARTS: "Nautical Charts",
	SANCTIONS: "Sanctions",
	KEY_AREAS: "Key Areas - TTW/ROI/TZ",
	MARITIME_BOUNDARIES: "Key Areas - Maritime Boundaries",
	CUSTOM_STANDARD_CLAIMS: "Custom - Claims",
	SHIPPING_LANES: "Shipping Lanes",
	OFFSHORE_INFRASTRUCTURE: "Offshore Infrastructure",
	STS_HOTSPOTS: "Ship-to-Ship Hotspots",
	PORTS: "Ports",
	PORT_ASSESSMENTS: "Port Assessments",
	MISS: "MISS",
	RISKINT_PORTS: "Risk Intelligence - Ports",
	TROPICAL_STORMS: "Environment - Tropical Storms",
	HAZARDS_FLOODS: "Environmental Hazards - Floods",
	HAZARDS_EARTHQUAKES: "Environmental Hazards - Earthquakes",
	HAZARDS_VOLCANOES: "Environmental Hazards - Volcanoes",
	ALERTS: "Vessels - Alerts",
	VESSEL_HISTORY: "Vessels - History Query",
	VESSELS_NEARBY: "Vessels - Nearby Query",
	VESSELS_SELECTED: "Vessels - Overlays",
	AIRCRAFT_ALERTS: "Aircraft - Alerts",
	AIRCRAFT_HISTORY: "Aircraft - History Query",
	GNSS_HOTSPOTS: "Aviation - GNSS Hotspots",
	NOTAMS: "NOTAMS",
	RISKINT_INCIDENTS: "Risk Intelligence - Incidents",
	// Vessel focus rect?
	MDA_SATCAP: "SAR-derived Dark Vessel Detection",
	CLEOS_SATRF: "Satellite-derived RF Detection",
	ROUTE_PLOT: "Route Plotting",
	CUSTOM_LAYERS: "Custom Layers",
	ENVIRONMENT: "Environment",
	TIMEZONES: "Timezones"

};
export default MapLayerGroup;
